/* @generated from adl module SrcLoc */

import * as ADL from './runtime/adl';

export type Line = number;

const Line_AST : ADL.ScopedDecl =
  {"moduleName":"SrcLoc","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}},"name":"Line","version":{"kind":"nothing"}}};

export const snLine: ADL.ScopedName = {moduleName:"SrcLoc", name:"Line"};

export function texprLine(): ADL.ATypeExpr<Line> {
  return {value : {typeRef : {kind: "reference", value : snLine}, parameters : []}};
}

export type Col = number;

const Col_AST : ADL.ScopedDecl =
  {"moduleName":"SrcLoc","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}},"name":"Col","version":{"kind":"nothing"}}};

export const snCol: ADL.ScopedName = {moduleName:"SrcLoc", name:"Col"};

export function texprCol(): ADL.ATypeExpr<Col> {
  return {value : {typeRef : {kind: "reference", value : snCol}, parameters : []}};
}

export interface LineCol {
  line: Line;
  col: Col;
}

export function makeLineCol(
  input: {
    line: Line,
    col: Col,
  }
): LineCol {
  return {
    line: input.line,
    col: input.col,
  };
}

const LineCol_AST : ADL.ScopedDecl =
  {"moduleName":"SrcLoc","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"line","default":{"kind":"nothing"},"name":"line","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"SrcLoc","name":"Line"}},"parameters":[]}},{"annotations":[],"serializedName":"col","default":{"kind":"nothing"},"name":"col","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"SrcLoc","name":"Col"}},"parameters":[]}}]}},"name":"LineCol","version":{"kind":"nothing"}}};

export const snLineCol: ADL.ScopedName = {moduleName:"SrcLoc", name:"LineCol"};

export function texprLineCol(): ADL.ATypeExpr<LineCol> {
  return {value : {typeRef : {kind: "reference", value : snLineCol}, parameters : []}};
}

export interface LineColRange {
  start: LineCol;
  end: LineCol;
}

export function makeLineColRange(
  input: {
    start: LineCol,
    end: LineCol,
  }
): LineColRange {
  return {
    start: input.start,
    end: input.end,
  };
}

const LineColRange_AST : ADL.ScopedDecl =
  {"moduleName":"SrcLoc","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"start","default":{"kind":"nothing"},"name":"start","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"SrcLoc","name":"LineCol"}},"parameters":[]}},{"annotations":[],"serializedName":"end","default":{"kind":"nothing"},"name":"end","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"SrcLoc","name":"LineCol"}},"parameters":[]}}]}},"name":"LineColRange","version":{"kind":"nothing"}}};

export const snLineColRange: ADL.ScopedName = {moduleName:"SrcLoc", name:"LineColRange"};

export function texprLineColRange(): ADL.ATypeExpr<LineColRange> {
  return {value : {typeRef : {kind: "reference", value : snLineColRange}, parameters : []}};
}

export interface LineRange {
  startLine: Line;
  endLine: Line;
}

export function makeLineRange(
  input: {
    startLine: Line,
    endLine: Line,
  }
): LineRange {
  return {
    startLine: input.startLine,
    endLine: input.endLine,
  };
}

const LineRange_AST : ADL.ScopedDecl =
  {"moduleName":"SrcLoc","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"startLine","default":{"kind":"nothing"},"name":"startLine","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"SrcLoc","name":"Line"}},"parameters":[]}},{"annotations":[],"serializedName":"endLine","default":{"kind":"nothing"},"name":"endLine","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"SrcLoc","name":"Line"}},"parameters":[]}}]}},"name":"LineRange","version":{"kind":"nothing"}}};

export const snLineRange: ADL.ScopedName = {moduleName:"SrcLoc", name:"LineRange"};

export function texprLineRange(): ADL.ATypeExpr<LineRange> {
  return {value : {typeRef : {kind: "reference", value : snLineRange}, parameters : []}};
}

export interface SrcSpan_LineColRange {
  kind: 'lineColRange';
  value: LineColRange;
}
export interface SrcSpan_LineRange {
  kind: 'lineRange';
  value: LineRange;
}
export interface SrcSpan_LineCol {
  kind: 'lineCol';
  value: LineCol;
}
export interface SrcSpan_Line {
  kind: 'line';
  value: Line;
}

export type SrcSpan = SrcSpan_LineColRange | SrcSpan_LineRange | SrcSpan_LineCol | SrcSpan_Line;

export interface SrcSpanOpts {
  lineColRange: LineColRange;
  lineRange: LineRange;
  lineCol: LineCol;
  line: Line;
}

export function makeSrcSpan<K extends keyof SrcSpanOpts>(kind: K, value: SrcSpanOpts[K]) { return {kind, value}; }

const SrcSpan_AST : ADL.ScopedDecl =
  {"moduleName":"SrcLoc","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"lineColRange","default":{"kind":"nothing"},"name":"lineColRange","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"SrcLoc","name":"LineColRange"}},"parameters":[]}},{"annotations":[],"serializedName":"lineRange","default":{"kind":"nothing"},"name":"lineRange","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"SrcLoc","name":"LineRange"}},"parameters":[]}},{"annotations":[],"serializedName":"lineCol","default":{"kind":"nothing"},"name":"lineCol","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"SrcLoc","name":"LineCol"}},"parameters":[]}},{"annotations":[],"serializedName":"line","default":{"kind":"nothing"},"name":"line","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"SrcLoc","name":"Line"}},"parameters":[]}}]}},"name":"SrcSpan","version":{"kind":"nothing"}}};

export const snSrcSpan: ADL.ScopedName = {moduleName:"SrcLoc", name:"SrcSpan"};

export function texprSrcSpan(): ADL.ATypeExpr<SrcSpan> {
  return {value : {typeRef : {kind: "reference", value : snSrcSpan}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "SrcLoc.Line" : Line_AST,
  "SrcLoc.Col" : Col_AST,
  "SrcLoc.LineCol" : LineCol_AST,
  "SrcLoc.LineColRange" : LineColRange_AST,
  "SrcLoc.LineRange" : LineRange_AST,
  "SrcLoc.SrcSpan" : SrcSpan_AST
};
